import { tv, type VariantProps } from 'tailwind-variants';
export type AtSetLocationActionVariants = VariantProps<
  typeof atSetLocationAction
>;

const atSetLocationAction = tv({
  slots: {
    base: '',
    iconColor: '',
    iconSize: 'text-28',
    ctaText: '',
    resetText: '',
  },
  variants: {
    hasLocation: {
      true: '',
      false: '',
    },
    intent: {
      navigation: {
        base: 'flex flex-row items-center justify-center gap-1.5 py-1.5',
        ctaText: 'paragraph-md',
        iconColor: 'var(--color-ui-fill-tertiary)',
      },
      filter: {},
      hero: {
        base: 'flex flex-row items-center justify-center gap-1.5 py-1.5',
        ctaText: 'flex flex-row justify-center items-center paragraph-md',
        resetText: 'text-13',
        iconColor: 'var(--color-ui-fill-tertiary)',
      },
    },
  },
  compoundVariants: [
    {
      intent: 'filter',
      hasLocation: false,
      className: {
        iconColor: 'var(--color-ui-icon-primary)',
        iconSize: 'text-2xl',
        ctaText: 'cta-text-md',
        base: 'flex flex-row items-center justify-center gap-0.5 py-4 px-10 rounded-full outline outline-black outline-2',
      },
    },
    {
      intent: 'filter',
      hasLocation: true,
      className: {
        ctaText: 'paragraph-lg inline-flex justify-center items-center',
        iconColor: 'var(--color-ui-fill-tertiary)',
        base: 'flex flex-row items-center justify-center gap-1.5 py-1.5',
      },
    },
  ],
});

export default atSetLocationAction;
